import moment from "moment";
export default {
  data() {
    return {};
  },
  computed: {
    currentTime() {
      return moment().format("HH:mm");
    },
    currentDate() {
      return moment().format("D MMM YYYY");
    }
  },
  methods: {
    dateDiff(dateToCheck) {
      let now = moment().format("DD MM YYYY"); // NOW
      let exp = moment(dateToCheck).format("DD MM YYYY"); // EXP
      let nowDay = parseInt(now.slice(0, 2));
      let nowMonth = parseInt(now.slice(3, 5));
      let nowYear = parseInt(now.slice(-4));
      let nowCalc = moment([nowYear, nowMonth, nowDay]);
      let expDay = parseInt(exp.slice(0, 2));
      let expMonth = parseInt(exp.slice(3, 5));
      let expYear = parseInt(exp.slice(-4));
      let expCalc = moment([expYear, expMonth, expDay]);
      let d = expCalc.diff(nowCalc, "days"); // 1
      return d;
    },
    dateExpired(dateToCheck) {
      let now = moment().format("DD MM YYYY"); // NOW
      let exp = moment(dateToCheck).format("DD MM YYYY"); // EXP
      let nowDay = parseInt(now.slice(0, 2));
      let nowMonth = parseInt(now.slice(3, 5));
      let nowYear = parseInt(now.slice(-4));
      let expDay = parseInt(exp.slice(0, 2));
      let expMonth = parseInt(exp.slice(3, 5));
      let expYear = parseInt(exp.slice(-4));
      let logic = null;
      // eslint-disable-next-line
      if (expYear > nowYear) {
        logic = false;
      } else if (expYear === nowYear && expMonth > nowMonth) {
        logic = false;
      } else if (
        expYear === nowYear &&
        expMonth === nowMonth &&
        expDay === nowDay
      ) {
        logic = false;
      } else {
        logic = true;
      }
      return logic;
    },
    dateTypeA(u) {
      if (u === "" || u === undefined) {
        return "NE";
      } else {
        return moment(u).format("D MMM YYYY");
      }
    },
    dateTypeB(u) {
      if (u === "" || u === undefined) {
        return "NE";
      } else {
        return moment(u).format("D MMM YYYY, hh:mm:ss");
      }
    },
    dateTimeAgo(u) {
      let txt = "";
      if (u === "" || u === undefined) {
        txt = "No Date";
      } else {
        txt = moment(u).fromNow(true);
        txt = txt + " ago";
      }
      return txt;
    },
    dateTypeBWithTimeAgo(u) {
      let date = null;
      let ago = null;
      let combined = null;
      if (u !== "" && u !== undefined) {
        date = moment(u).format("D MMM YYYY, hh:mm:ss");
        ago = moment(u).fromNow(true) + " ago";
        combined = date + " - " + ago;
      } else {
        combined = "No Date";
      }
      return combined;
    },
    generateFutureDate(u) {
      if (u === "1D") {
        // eslint-disable-next-line
        return moment().add(1, "days").format();
      } else if (u === "3D") {
        // eslint-disable-next-line
        return moment().add(2, "days").format();
      } else if (u === "1W") {
        // eslint-disable-next-line
        return moment().add(7, "days").format();
      } else if (u === "2W") {
        // eslint-disable-next-line
        return moment().add(14, "days").format();
      } else if (u === "1M") {
        // eslint-disable-next-line
        return moment().add(1, "months").format();
      } else if (u === "2M") {
        // eslint-disable-next-line
        return moment().add(2, "months").format();
      } else if (u === "3M") {
        // eslint-disable-next-line
        return moment().add(3, "months").format();
      } else if (u === "4M") {
        // eslint-disable-next-line
        return moment().add(4, "months").format();
      } else if (u === "6M") {
        // eslint-disable-next-line
        return moment().add(6, "months").format();
      } else if (u === "9M") {
        // eslint-disable-next-line
        return moment().add(9, "months").format();
      } else if (u === "1Y") {
        // eslint-disable-next-line
        return moment().add(12, "months").format();
      } else {
        return "";
      }
    },
    dateFuture(u) {
      if (u === "1D") {
        // eslint-disable-next-line
        return moment().add(1, "days").format();
      } else if (u === "3D") {
        // eslint-disable-next-line
        return moment().add(2, "days").format();
      } else if (u === "1W") {
        // eslint-disable-next-line
        return moment().add(7, "days").format();
      } else if (u === "2W") {
        // eslint-disable-next-line
        return moment().add(14, "days").format();
      } else if (u === "1M") {
        // eslint-disable-next-line
        return moment().add(1, "months").format();
      } else if (u === "2M") {
        // eslint-disable-next-line
        return moment().add(2, "months").format();
      } else if (u === "3M") {
        // eslint-disable-next-line
        return moment().add(3, "months").format();
      } else if (u === "4M") {
        // eslint-disable-next-line
        return moment().add(4, "months").format();
      } else if (u === "6M") {
        // eslint-disable-next-line
        return moment().add(6, "months").format();
      } else if (u === "9M") {
        // eslint-disable-next-line
        return moment().add(9, "months").format();
      } else if (u === "1Y") {
        // eslint-disable-next-line
        return moment().add(12, "months").format();
      } else {
        return "";
      }
    }
  }
};
